import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ErrorDialogManagerService {
  private errorSubject: BehaviorSubject<any> = new BehaviorSubject(null);

  constructor() {}

  getErrors(): Observable<any> {
    return this.errorSubject;
  }

  error(component, data) {
    this.errorSubject.next({ component, data });
  }
}
